import http from '@/services/http'
import httpForm from '../../http-form'

export const createFidelityCampaign = (id, payload) =>
  http.post(`challenges/${id}`, payload)
export const uploadFidelityCampaignRulesFile = (id, payload) =>
  httpForm.patch(`challenges/rules/${id}`, payload)
export const updateFidelityCampaignStatus = (id) => http.patch(`challenges/status/${id}`)
export const deleteFidelityCampaign = (id) => http.delete(`challenges/${id}`)
export const getFidelityCampaign = (id) => http.get(`challenges/details/${id}`)
export const updateFidelityCampaign = (id, payload) =>
  http.patch(`challenges/${id}`, payload)
export const getAllFidelityCampaign = ({ page, query }) =>
  http.get(`challenges/all?page=${page}${query}`).then((res) => res.data)

export const getBalanceProvisioning = (id) =>
  http.get(`challenges/balance-provisioning/${id}`).then((res) => res.data)

export const getProductListCampaign = (id = '') =>
  http.get(`products/enable-in-partners-challenge/${id}`).then((res) => res.data)

export const getPartnersList = () =>
  http.get('partners/campaignFidelityEnable').then((res) => res.data)

// Get list of participants by tableId.
export const getParticipants = (tableId, page, query) =>
  http
    .get(`/users-challenges/specific-users/${tableId}?page=${page}${query}`)
    .then((res) => res)

// Remove table
export const removeParticipantsTable = (tableId) =>
  http.delete(`users-challenges/specific-users/${tableId}`)

// Remove participant line from table
export const removeParticipant = (lineId) =>
  http.delete(`/users-challenges/specific-user/${lineId}`)

// Get users table by challengeId
export const getParticipantsTableByChallengeId = (challengeId, page, query) =>
  http.get(
    `users-challenges/specific-users-by-partners-challenge/${challengeId}?page=${page}${query}`
  )

// Send table to api
export const sendFile = (fileToUpload, partnerId) => {
  const { name, type } = fileToUpload

  const formData = new FormData()

  formData.append('name', name)
  formData.append('type', type)
  formData.append('partner', partnerId)
  formData.append('file', fileToUpload)

  return http.post('users-challenges/specific-users', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
